<template lang="pug">
.fam-stack
  avatar-stack(:avatars="avatars")
  .copy {{avatars.length}}位参观者


</template>
<script>
import AvatarStack from '@/components/wedgits/AvatarStack'
import { mapState } from 'vuex'
export default {
  name: 'FamStack',
  components: { AvatarStack },
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['user']),
    avatars() {
      return [this.user.avatar, ...this.user.famUsers]
    },
  },
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.fam-stack
  width: 100%
  display: flex
  justify-content: space-between
  align-items: center
  flex-direction: row
  .copy
    font-size: pxToRem(26)
    color: black
</style>
